<template>
    <div id="SysCleanFile">
        <eb-header>
            <eb-break-crumb slot="breakCrumb" />
        </eb-header>
        <div>
            <el-button class="eb-button-group-btn eb-button-orange button" @click="submitForm">清理文件</el-button>
            <div id="cleanFileProgressInfo"></div>
        </div>
    </div>
</template>
<script>
import ebHeader from '@/components/common/eb-header';
import ebBreakCrumb from '@/components/common/eb-break-crumb';
import $ from 'jquery';
import { baseURL } from '@/plugins/axios.js';
export default {
  name: 'SysCleanFile',
  components: {
    ebHeader,
    ebBreakCrumb
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    submitForm: function() {
      this.$ebConfirm('您确定要清理文件吗？')
        .then(() => {
          this.confirmClennFile();
        })
        .catch(() => {});
    },
    async confirmClennFile() {
      try {
        let cleanFileInfoArea = $('#cleanFileProgressInfo');
        let es = new EventSource(baseURL + '/api/system/cleanFileProcess');
        es.onmessage = function(e) {
          cleanFileInfoArea.append(e.data);
        };

        es.addEventListener(
          'disconnect',
          function(e) {
            es.close();
            cleanFileInfoArea.append(e.data);
          },
          false
        );
      } catch (error) {
        this.$message.error('请检查服务器连接!');
      }
    }
  }
};
</script>
<style scoped lang="less">
#SysCleanFile {
  .button {
    height: 35px;
    width: 80px;
    margin: 10px 10px 0px 10px;
  }
  #cleanFileProgressInfo {
    margin: 10px;
    width: 98%;
    height: 800px;
    overflow: auto;
    color: #feefa9;
    font-family: Courier New, Courier, monospace;
    background-color: #1b763f;
    font-weight: bold;
  }
}
</style>
